import { FC } from 'react';
import { Root, Title } from './styled';

type Props = {
  title: string;
};

const EditDesiredTitle: FC<Props> = ({ title }) => {
  return (
    <Root>
      <Title>{title}</Title>
    </Root>
  );
};

export default EditDesiredTitle;
